import { Alert, AlertTitle } from '@mui/material';
import {
  useAppDispatch,
  useAppSelector,
} from '../../storeHook';
import './index.scss';
import { TAlert } from '../../utils/types';
import { useEffect } from 'react';
import { removeAlert } from '../../services/alert';

const AppAlert = ({ alert }: { alert: TAlert }) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(removeAlert(alert.id!));
    }, alert.alertTime);
    return () => {
      clearTimeout(timer);
    };
  }, [alert]);

  // Define custom color styling based on alert severity
  const getAlertStyle = () => {
    switch (alert.severity) {
      case 'error':
        return {
          backgroundColor: 'rgba(195, 21, 21, 1)',
          color: '#fff', // Bright red for error text
          '& .MuiAlert-icon': {
            color: '#fff', // Bright red for icon
          },
        };
      case 'success':
        return {
          backgroundColor: 'rgba(35, 105, 1, 1)',
          color: '#fff', // Green for success text
          '& .MuiAlert-icon': {
            color: '#fff', // Green for icon
          },
        };
      default:
        return {}; // Default styles for other severities
    }
  };

  return (
    <Alert
      severity={alert.severity}
      className="app-alert mt-3"
      sx={getAlertStyle()}>
      {alert.title && (
        <AlertTitle>{alert.title}</AlertTitle>
      )}
      {alert.content}
    </Alert>
  );
};

export const AppAlerts = () => {
  const alerts = useAppSelector((state) => state.alerts);

  return (
    <div className="app-alerts-container">
      {alerts.map((alert) => (
        <div key={alert.id}>
          <AppAlert alert={alert} />
        </div>
      ))}
    </div>
  );
};
